export const PAYOUT_OVERRIDE_GENERATE = 'PAYOUT_OVERRIDE_GENERATE';

export default {
  PAYOUT_OVERRIDE_GENERATE,
};
